import React, { useCallback } from 'react';
import { MessageCircle, Facebook, ChevronUp } from 'lucide-react';
import { SOCIAL_LINKS, CONTACT_INFO, ASHUD_INFO } from '../utils/constants';

const FloatingSocialButtons = () => {
  // Memoized handlers for better performance
  const handleWhatsAppClick = useCallback(() => {
    const message = encodeURIComponent(`Bonjour ${ASHUD_INFO.name} ! Je souhaite en savoir plus sur vos actions humanitaires.`);
    const phoneNumber = CONTACT_INFO.phone.replace('+', '');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  }, []);

  const handleFacebookClick = useCallback(() => {
    window.open(SOCIAL_LINKS.facebook, '_blank');
  }, []);

  const handleScrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {/* Bouton WhatsApp */}
      <button
        onClick={handleWhatsAppClick}
        className="bg-white text-success hover:bg-surface border border-line p-3 rounded shadow-card transition-colors duration-200"
        title="Contactez-nous sur WhatsApp"
        aria-label="Contactez-nous sur WhatsApp"
      >
        <MessageCircle className="w-5 h-5" />
      </button>

      {/* Bouton Facebook */}
      <button
        onClick={handleFacebookClick}
        className="bg-white text-primary hover:bg-surface border border-line p-3 rounded shadow-card transition-colors duration-200"
        title="Suivez-nous sur Facebook"
        aria-label="Suivez-nous sur Facebook"
      >
        <Facebook className="w-5 h-5" />
      </button>

      {/* Bouton Retour en haut */}
      <button
        onClick={handleScrollToTop}
        className="bg-white text-ink hover:bg-surface border border-line p-3 rounded shadow-card transition-colors duration-200"
        title="Retour en haut"
        aria-label="Retour en haut"
      >
        <ChevronUp className="w-5 h-5" />
      </button>
    </div>
  );
};

export default FloatingSocialButtons;
